
export interface IVrlTransactionRequest {
    orderId: number,
    donorCenter: string,
    donorAlias: string,
    donorId: number,
    recipientCenter: string,
    recipientAlias: string,
    recpId: number,
    swapNumber: number,
    clusterNumber: number,
    position: number,
    requestedDate: string,
    shipBackDate: string,
    completed: string,
    requested: string
}